export default __webpack_public_path__ + "static/media/asteroid_belt_icon.875d125c.png";